export interface ConfigureAttributeSaver {
	validate: () => string[];
	save: () => Promise<void>;
}

let registered: ConfigureAttributeSaver | null = null;

export const registerConfigureAttributeSaver = (saver: ConfigureAttributeSaver) => {
	registered = saver;
};

export const clearConfigureAttributeSaver = () => {
	registered = null;
};

export const getConfigureAttributeSaver = (): ConfigureAttributeSaver | null =>
	registered;